import {
  BottomSheet,
  BottomSheetContent,
  LightboxStage,
} from '@relay-towing/ui';

/**
 * One photo full size, in a sheet over the screen that opened it: an
 * inspection's. Open while `src` is set; closing it calls `onClose`, which
 * clears it. A call's photos open in their own PhotoSheet, with comments.
 */
export function PhotoViewer({
  src,
  alt,
  title = 'Photo',
  onClose,
}: {
  src: string | null;
  /** What the photo is, for a screen reader: "Call photo". */
  alt: string;
  title?: string;
  onClose: () => void;
}) {
  return (
    <BottomSheet
      open={src !== null}
      onOpenChange={(open) => !open && onClose()}
    >
      <BottomSheetContent title={title} size="full">
        {src ? <LightboxStage src={src} alt={alt} /> : null}
      </BottomSheetContent>
    </BottomSheet>
  );
}
